<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="container-fluid">
  <div class="row align-items-center">
    <div class="col-auto">
      <h5 class="title-secondary">
        {{ 'CITIES.CITIES_LIST.TITLE' | translate }}
        <span *ngIf="country">{{ 'CITIES.CITIES_LIST.IN' | translate }} {{ country.name }}</span>
      </h5>
    </div>
    <div class="col-auto ms-auto">
      <button
        *ngIf="accessService.hasAccess([UserRoleType.LEAD_GENERATION], ['cities.store'])"
        type="button"
        class="btn btn-secondary"
        (click)="add()"
      >
        {{ 'CITIES.CITIES_LIST.ADD_CITY' | translate }}
      </button>
    </div>
  </div>
  <kendo-grid
    [data]="data"
    [pageSize]="citiesResponse?.meta.per_page"
    [sortable]="true"
    [filterable]="true"
    [columnMenu]="true"
    [filter]="state?.filter"
    [sort]="state?.sort"
    [skip]="state?.skip"
    [pageable]="true"
    (dataStateChange)="loadData($event)"
    (columnVisibilityChange)="onVisibilityChange($event)"
    #grid
    (excelExport)="onExcelExport($event, 'Cities', grid)"
  >
    <kendo-grid-column
      [width]="70"
      class="text-center"
      headerClass="text-center"
      title="{{ 'CITIES.CITIES_LIST.NUMBER' | translate }}"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ rowIndex + 1 }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="id"
      title="{{ 'CITIES.CITIES_LIST.ID' | translate }}"
      filter="numeric"
      [width]="150"
      [hidden]="isHiddenColumn('id')"
    ></kendo-grid-column>

    <kendo-grid-column
      field="name"
      title="{{ 'CITIES.CITIES_LIST.NAME' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('name')"
    ></kendo-grid-column>

    <kendo-grid-column
      field="lat"
      title="{{ 'CITIES.CITIES_LIST.LAT' | translate }}"
      filter="numeric"
      [hidden]="isHiddenColumn('lat')"
    ></kendo-grid-column>

    <kendo-grid-column
      field="long"
      title="{{ 'CITIES.CITIES_LIST.LONG' | translate }}"
      filter="numeric"
      [hidden]="isHiddenColumn('long')"
    ></kendo-grid-column>

    <kendo-grid-column
      field="timezone"
      title="{{ 'CITIES.CITIES_LIST.TIMEZONE' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('timezone')"
    ></kendo-grid-column>

    <kendo-grid-column
      field="created_at"
      title="{{ 'CITIES.CITIES_LIST.CREATED_AT' | translate }}"
      filter="date"
      format="{0:dd/MM/yyyy}"
      [hidden]="isHiddenColumn('created_at', true)"
    >
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="eq"></kendo-grid-date-filter-cell>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.created_at.getDate() }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="active"
      title="{{ 'CITIES.CITIES_LIST.ACTIVE' | translate }}"
      filter="boolean"
      [width]="150"
      [class]="'text-center'"
      [hidden]="isHiddenColumn('active')"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <app-active-indicator [active]="dataItem.active"></app-active-indicator>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      title="{{ 'CITIES.CITIES_LIST.ACTIONS' | translate }}"
      [width]="100"
      [class]="'text-center'"
      [includeInChooser]="false"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <app-edit-button
          *ngIf="accessService.hasAccess([UserRoleType.LEAD_GENERATION], ['cities.show'])"
          (click)="edit(dataItem, country)"
        >
        </app-edit-button>

        <app-seo-button
          *ngIf="accessService.hasAccess([UserRoleType.IT, UserRoleType.MARKETING], ['cities.translations'])"
          (click)="editSeo(dataItem)"
        ></app-seo-button>

        <app-media-library-button
          *ngIf="accessService.hasAccess([UserRoleType.IT, UserRoleType.MARKETING], ['media.index'])"
          [ngbTooltip]="'CITIES.CITIES_LIST.UPLOAD_IMAGES' | translate"
          container="body"
          [collectionName]="'gallery'"
          [acceptType]="MediaLibraryAcceptTypes.IMAGES"
          [modelId]="dataItem.id"
          [modelType]="LaravelModels.CITY"
        >
        </app-media-library-button>

        <app-delete-button
          *ngIf="accessService.hasAccess([UserRoleType.LEAD_GENERATION], ['cities.destroy'])"
          [swal]="{}"
          (confirm)="delete(dataItem)"
        >
        </app-delete-button>

        <!--        <app-activities [subjectType]="laravelModels.CITY" [subjectId]="dataItem.id"></app-activities>-->
      </ng-template>
    </kendo-grid-column>

    <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
      <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
      <kendo-pager-input></kendo-pager-input>
      <kendo-pager-info></kendo-pager-info>
      <kendo-pager-next-buttons></kendo-pager-next-buttons>
      <kendo-pager-page-sizes [pageSizes]="env.kendoGridPageSizes"></kendo-pager-page-sizes>
      <app-kendo-grid-refresh-button (click)="loadData(state)"></app-kendo-grid-refresh-button>
      <button type="button" class="btn kendo-export-btn" [disabled]="grid.loading" kendoGridExcelCommand>
        {{ 'EXPORT_TO_EXCEL' | translate }}
      </button>
    </ng-template>

    <kendo-grid-excel></kendo-grid-excel>
  </kendo-grid>
</div>
